export const NAME_SPACE = 'Map/';
export const ROOT_STATE_KEY = 'map';
